import moment, { Moment } from 'moment';

// 픽업 시간은 5분 단위로 고르므로 입력 후 전송까지 시간이 흐르면 이미 지난 시각이 될 수 있다.
// 지난 시각이면 now + 1분으로 보정해 보낸다. 화면 선택 단위(5분)와는 무관하게 전송값에만 적용
// eslint-disable-next-line import/prefer-default-export
export const toSendAppointmentDate = (appointmentDate?: Moment | string) => {
  const appointment = moment(appointmentDate);
  const now = moment();

  return (appointment.isBefore(now) ? now.add(1, 'minute') : appointment).format('YYYY-MM-DDTHH:mm');
};
